<template>
    <div>
        <div class="timer__tile" :class="{ 'ends-tonight': endsTonight }">
            <div class="timer__digit">
                <span id="days">{{ timer.days.digit }}</span>
            </div>
            <span class="timer__title">{{ timer.days.title }}</span>
        </div>
        <div class="timer__tile">
            <div class="timer__digit">
                <span>{{ timer.hours.digit }}</span>
            </div>
            <span class="timer__title">{{ timer.hours.title }}</span>
        </div>
        <div class="timer__tile">
            <div class="timer__digit">
                <span>{{ timer.minutes.digit }}</span>
            </div>
            <span class="timer__title">{{ timer.minutes.title }}</span>
        </div>
        <div class="timer__tile">
            <div class="timer__digit">
                <span>{{ timer.seconds.digit }}</span>
            </div>
            <span class="timer__title">{{ timer.seconds.title }}</span>
        </div>
    </div>
</template>

<script>
import { setTimerMixin } from '../../mixins/setTimerMixin';
export default {
    mixins: [setTimerMixin],
    props: {
        timerEndtime: {},
    },
};
</script>
